import React from 'react';
import { Outlet } from 'react-router-dom';
import classNames from 'classnames';
import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import Footer from 'components/footer/Footer';
import CourseProvider from 'components/app/e-learning/CourseProvider';
import useMainLayout from 'hooks/useMainLayout';
import Charging from 'components/common/Charging';
//import SettingsToggle from 'components/settings-panel/SettingsToggle';
import MainProvider from 'providers/MainProviders';
import ArticleProvider from 'providers/ArticleProvider';
import ProductProvider from 'providers/ProductProvider';

const MainLayout = () => {
 const { isFluid, navbarPosition, isKanban, isLoading } = useMainLayout();

 if (isLoading) return <Charging />;

 return (
  <div className={isFluid ? 'container-fluid' : 'container'}>
   {(navbarPosition === 'vertical' || navbarPosition === 'combo') && <NavbarVertical />}
   <MainProvider>
    <ArticleProvider>
     <ProductProvider>
      <CourseProvider>
       <div className={classNames('content', { 'pb-0': isKanban })}>
        <NavbarTop />
        {/*------ Main Routes ------*/}
        <Outlet />
        {!isKanban && <Footer />}

        {/* <SettingsToggle /> */}
       </div>
      </CourseProvider>
     </ProductProvider>
    </ArticleProvider>
   </MainProvider>
  </div>
 );
};

export default MainLayout;
